import { ChevronRight } from '@ixigo/icons';
import Alert from '@ixigo/icons/Alert';
import { Carousel, CarouselItem } from '@ixigo/iui/Carousel';
import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { FC, useCallback, useEffect, useState } from 'react';
import { getDowntime } from '../../apis/downtime';
import { formatDate, isMobile } from '../../utils/common';
import { DowntimeAlert as DowntimeAlertType } from './index.types';

const controlBtnClass =
    'relative inline-flex justify-center items-center w-40 h-40 text-primary-500 bg-white rounded-full shadow-500';

const DowntimeAlert: FC = () => {
    const [data, setData] = useState<DowntimeAlertType[]>([]);
    const isMob = isMobile();
    const multiple = data.length > 1;

    const fetchDowntime = useCallback(async () => {
        try {
            const response = await getDowntime();
            setData(response);
        } catch (e) {
            // No-op
        }
    }, []);

    useEffect(() => {
        fetchDowntime();
    }, [fetchDowntime]);

    if (!data.length) return null;

    return (
        <div className={clsx('bg-white', isMob && 'pt-20', multiple && 'pb-9', isMob && !multiple && 'p-20')}>
            <Carousel
                className={clsx(isMob && 'scroll-p-20')}
                indicatorsType={multiple && 'dot'}
                nextControlIcon={
                    <span className={controlBtnClass}>
                        <ChevronRight />
                    </span>
                }
                prevControlIcon={
                    <span className={controlBtnClass}>
                        <ChevronRight className='rotate-180' />
                    </span>
                }
                buttonControls={!isMob && multiple}
            >
                {data.map((item) => (
                    <CarouselItem
                        className={clsx(
                            'flex gap-10 p-10 bg-yellow-50 border border-yellow-300',
                            multiple ? 'max-w-[75%]' : 'w-full',
                            isMob && multiple && 'first-of-type:ml-20 last-of-type:mr-20',
                        )}
                    >
                        <Alert className='shrink-0 text-yellow-700' fontSize={20} />
                        <div>
                            <Typography variant='body-sm'>{item.service} is currently unavailable</Typography>
                            <Typography variant='body-xs' className='text-charcoal-600'>
                                We&apos;re currently experiencing an ongoing downtime with {item.service}. Our team is
                                working to resolve this issue as soon as possible.{' '}
                                {item.alert_detail?.[0] &&
                                    `The downtime is expected to end by ${formatDate(item.alert_detail[0].end_time, 'dd MMM, HH:mm')}. `}
                                Thank you for your patience!
                            </Typography>
                        </div>
                    </CarouselItem>
                ))}
            </Carousel>
        </div>
    );
};

export default DowntimeAlert;
